import { tsoPqTheme } from '@assets/style/customTsoPqtheme';
import ButtonTsoPq from '@components/Buttons/ButtonTsoPq';
import IconButtonTsoPq from '@components/Buttons/IconButtonTsoPq';
import { colorMap } from '@components/ChipSelector/ChipSelectorTsoPq';
import TypographyTsoPq from '@components/Typography/TypographyTsoPq';
import styled from '@emotion/styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box } from '@mui/material';

export const StyledButtonWrapper = styled(Box)({
  margin: '0 0 0 auto',
  paddingTop: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_12,
  display: 'flex',
  justifyContent: 'flex-end',
  gap: tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_page_gap_xxs,
});

export const StyledContentWrapper = styled(Box)({
  width: '100%',
  paddingTop: tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_24,
});

export const StyledContent = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_24,
});

export const StyledHeaderContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
});

export const StyledContentTitle = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_8,
});

export const StyledContentContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_24,
});

export const StyledTrendsContainer = styled(Box)(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    width: '97%',
    minWidth: 0,
  };
});
export const StyledTrendsChartTitle = styled(Box)(() => {
  return {
    width: '100%',
  };
});
export const StyledTrendsChartSubtitle = styled(Box)(() => {
  return {
    width: '100%',
    marginTop: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_4,
    paddingBottom: tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_24,
  };
});

export const StyledTrendsChartActionsContainer = styled(Box)(() => {
  return {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_24,
  };
});

export const StyledTrendsChartActionBox = styled(Box)(() => {
  return {
    width: '27rem',
  };
});
export const StyledTrendsChartActionBox2 = styled(Box)(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '27rem',
  };
});
export const StyledTrendsChartActionBox3 = styled(Box)(() => {
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_8,
    width: '27rem',
  };
});

export const StyledTrendsChartContainer = styled(Box)(() => {
  return {
    minWidth: '0px',
    display: 'flex',
    flexDirection: 'column',
    background: tsoPqTheme.palette.background.other.color_other_background_white,
    gap: '0.62rem',
    marginBottom: '1.5rem',
  };
});

export const StyledChartHeader = styled(Box)(() => {
  return {
    display: 'flex',
    flexDirection: 'row',
    color: tsoPqTheme.palette.customTextColor.color_font_ft_text,
    textAlign: 'center',
    fontFamily: tsoPqTheme.typography.openSans,
    fontSize: tsoPqTheme.typography.fontsize_body_body_large,
    fontStyle: 'normal',
    fontWeight: 700,
    gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_8,
    padding: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_12,
    alignItems: 'center',
  };
});

export const StyledChartsWrapper = styled(Box)(() => {
  return {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '1rem',
  };
});

export const StyledChartItem = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'chartsCount',
})<{ chartsCount: number }>(({ chartsCount }) => {
  const width = chartsCount > 1 ? 'calc(50% - 0.5rem)' : '100%';
  return {
    flex: `1 1 ${width}`,
    minWidth: '300px',
  };
});

export const StyledAccordionWrapper = styled(Box)({
  width: '79rem',
});

export const StyledTableContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_24,
});

export const StyledTableContainerHeaderWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_4,
});

export const StyledAccordionContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_16,
});

export const StyledApplyButton = styled(ButtonTsoPq, {
  shouldForwardProp: (prop) => prop !== 'hasError',
})<{ hasError?: boolean }>(({ hasError }) => ({
  margin: hasError ? 'auto 0 1.25rem auto' : 'auto 0.75rem 0.375rem auto',
}));

export const StyledTableWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
});

export const StyledRowHeaderCell = styled(Box)({});

export const StyledCellHeader = styled(Box)({
  display: 'flex',
  alignContent: 'center',
  gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_8,
});

export const StyledRowHeaderSubtitle = styled(TypographyTsoPq)({
  padding: `0 0 0 1.125rem`,
  color: tsoPqTheme.palette.customTextColor.color_font_ft_helping_text,
});

const abbreviationToColorKey: Record<string, keyof typeof colorMap> = {
  FiftyHZT: '50Hertz',
  AMP: 'Amprion',
  TTG: 'Tennet',
  TNG: 'TransnetBW',
};

export const TsoIentifier = styled(Box)(({ tsoAbbreviation }: { tsoAbbreviation: string }) => {
  const colorKey = abbreviationToColorKey[tsoAbbreviation] ?? 'default';
  const background = colorMap[colorKey]?.active ?? colorMap.default.active;

  return {
    alignSelf: 'center',
    background,
    height: '10px',
    width: '10px',
    borderRadius: '50%',
  };
});

export const StyledCellValue = styled(TypographyTsoPq)({
  height: '100%',
  width: '100%',
  display: 'flex',
  gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_8,
  alignItems: 'center',
  justifyContent: 'flex-start',
  alignSelf: 'center',
});

export const StyledNoTrendContainer = styled(Box)({
  height: '13.5625rem',
  background: tsoPqTheme.palette.background.other.color_other_background_white,
  display: 'flex',
  flexDirection: 'column',
  gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_8,
  padding: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_24,
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: tsoPqTheme.shape.border_radius_tso_border_radius_4,
});

export const StyledNoTrendTitleContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_12,
  color: tsoPqTheme.palette.customTextColor.color_font_ft_second_text,
});

export const StyledNoTrendDescriptionContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  textAlign: 'center',
  color: tsoPqTheme.palette.customTextColor.color_font_ft_helping_text,
});

export const StyledIcon = styled(FontAwesomeIcon)({
  color: tsoPqTheme.palette.customError.color_signal_error_error,
  margin: 'auto',
});

export const StyledCellWrapper = styled(Box)({
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
});

export const StyledChartIcon = styled(IconButtonTsoPq)({
  marign: 'auto',
});

export const StyledChartPlaceholder = styled(Box)({
  display: 'flex',
  width: '79rem',
  alignItems: 'center',
  justifyContent: 'center',
  flexGrow: 1,
  backgroundColor: tsoPqTheme.palette.customTextColor.color_font_ft_white,
});
